import gql from "graphql-tag";
const getResultQuery = gql(` 
query GetRawResults($userid: String!, $result: String!) {
  getRawResults(userid: $userid, result: $result) {
  userid,
  result,
  json
  } 
}   
`)
export default getResultQuery
